import { MapType, MapMarkerResponse, MapMarkersRequest } from '../types/maps';
import { goClient } from '../utils/httpClientTs';

// Real API functions
export const getMapTypes = async (): Promise<MapType[]> => {
  console.log(
    '🗺️ API Call: GET /maps/types (using hardcoded types until backend endpoint is ready)'
  );

  // TODO: When backend implements GET /maps/types endpoint, replace with:
  // return get<MapType[]>('/maps/types');

  // Hardcoded types for now (matches backend enum: 'chapters', 'members')
  return [
    { id: 'chapters', name: 'Chapters' },
    { id: 'members', name: 'Members' },
  ];
};

export const getMapMarkers = async (
  request: MapMarkersRequest
): Promise<MapMarkerResponse> => {
  const response = await goClient({
    url: `/maps/markers`,
    method: 'POST',
    data: request,
  });
  return response.data;
};
